import {Component} from '@angular/core';
import {Events, IonicPage, ModalController, NavController, NavParams, PopoverController} from 'ionic-angular';
import * as moment from "moment";
import {UserStatsProvider} from "../../providers/user-stats/user-stats";
import {UserStats} from "../../providers/api-course-data/user-state-dto";
import {UserProgressStateProvider} from "../../providers/user-progress-state/user-progress-state";
import {ContentTranslationProvider} from "../../providers/content-translation/content-translation";
import {DatePickerPopoverPage} from "../date-picker-popover/date-picker-popover";
import {InsuranceProvider} from "../../providers/insurance/insurance";
import {WheelSelector} from "@ionic-native/wheel-selector";

/**
 * Generated class for the AppStepUpdatePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-app-step-update',
  templateUrl: 'app-step-update.html',
})
export class AppStepUpdatePage {
  errorVisible: boolean;

  selectedDateFormatted: string;
  selectedDate: Date = new Date();
  minDate: Date = new Date(2018, 1, 1);
  maxDate: Date = new Date();

  stepCount: string;

  selectOptions: any;

  activityType: any;
  activityLength: number;
  isNativeEnv: boolean = true;

  activities: any;

  activityLengthFormatted: string;

  constructor(public navCtrl: NavController, public navParams: NavParams, public modalCtrl: ModalController, private stats: UserStatsProvider, private progress: UserProgressStateProvider, public contentTranslation: ContentTranslationProvider, public popoverCtrl: PopoverController, public selector: WheelSelector, private events: Events) {
    moment.updateLocale('de', function () {
    });
    this.selectedDateFormatted = moment().format('dd, ll')

    if (!((window as any).cordova)) {
      this.isNativeEnv = false;
      console.log(this.isNativeEnv);
    }

    if (this.navParams.get('date')) {
      this.selectedDate = moment(this.navParams.get('date')).toDate();
      this.formatSelectedDate();
    }

    this.selectOptions = {
      cssClass: 'choose-activity-popover'
    }

  }


  formatSelectedDate() {
    // if (moment(this.selectedDate).format('YYYY-MM-DD') == moment().format('YYYY-MM-DD')) {
    //   this.selectedDateFormatted = this.contentTranslation.translateContent('Activity today');
    // } else {
      this.selectedDateFormatted = moment(this.selectedDate).format('dd, ll')
    // }
  }

  updateFormattedDate(event) {
    this.selectedDate = event;
    this.formatSelectedDate();
  }

  hideError() {
    this.errorVisible = false;
  }


  openedPopover: any;

  openDatePickerPopover(event) {
    this.openedPopover = this.popoverCtrl.create(
      DatePickerPopoverPage,
      {
        pastDateSelect: true,
        valueUpdated: (selectedDate) => {
          this.selectedDate = moment(selectedDate).toDate();
          this.formatSelectedDate();
        }
      },
      {cssClass: 'date-picker-popover-container'}
    );
    this.openedPopover.present({
      ev: event,
    });
  }

  cancelInputClick(ev) {
    console.log(ev);

    this.openDatePickerPopover(ev);
    ev.stopPropagation();
  }

  goNext() {
    if (this.activityType == 0 && (!this.stepCount || parseInt(this.stepCount) <= 0)) {
      this.errorVisible = true;
      return;
    }
    if (this.activityType != 0 && (!this.activityLength || this.activityLength <= 0)) {
      this.errorVisible = true;
      return;
    }

    var goalReached = this.events.publish('activity:tracked', {})

    var me = this;
    if (this.activityType == 0) {
      this.stats.getUserStats(moment(this.selectedDate.toISOString()).format('YYYY-MM-DD')).then((stats: UserStats) => {
        stats.steps = parseInt(me.stepCount.replace('.', '').replace(',', ''));
        me.stats.updateData(stats);
        me.navCtrl.pop();
      });
    } else {
      this.stats.getUserStats(moment(this.selectedDate.toISOString()).format('YYYY-MM-DD')).then((stats: UserStats) => {
        this.stats.addActivity({
          date: moment(this.selectedDate.toISOString()).format('YYYY-MM-DD'),
          type: this.activityType,
          length: this.activityLength
        }).then((_stats: any) => {
          stats.steps = _stats.steps;
          stats.activitySum = _stats.activitySum;
          stats.extraActivitySum = _stats.extraActivitySum;
          stats.activityDaysCount = _stats.activityDaysCount;
          stats.groups = _stats.groups;
          me.stats.updateData(stats);

          me.navCtrl.pop();
        });
      });


    }


  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad AppStepUpdatePage');
    if (this.navParams.get('steps')) {
      this.activityType = '0';
    }

    this.activities = [];
    for(var i = 1; i<16;i++) {
      this.activities.push({id: i, label: this.contentTranslation.translateContent('Activity ' + i)});
    }
    this.activities.sort((a,b) => {
      return (a.label > b.label) ? 1: -1;
    })
  }

  selectActivityLength() {

    let hoursSelect = [
      { description: '0 Stunden', id: 0 },
      { description: '1 Stunde', id: 1 },
      { description: '2 Stunden', id: 2 },
      { description: '3 Stunden', id: 3 },
      { description: '4 Stunden', id: 4 },
      { description: '5 Stunden', id: 5 },
      { description: '6 Stunden', id: 6 },
      { description: '7 Stunden', id: 7 },
      { description: '8 Stunden', id: 8 },
      { description: '9 Stunden', id: 9 },
      { description: '10 Stunden', id: 10 },
      { description: '11 Stunden', id: 11 },
      { description: '12 Stunden', id: 12 },
    ];
    let minuteSelect = [
      { description: '0 Minuten', id: 0 },
      { description: '5 Minuten', id: 5 },
      { description: '10 Minuten', id: 10 },
      { description: '15 Minuten', id: 15 },
      { description: '20 Minuten', id: 20 },
      { description: '25 Minuten', id: 25 },
      { description: '30 Minuten', id: 30 },
      { description: '35 Minuten', id: 35 },
      { description: '40 Minuten', id: 40 },
      { description: '45 Minuten', id: 45 },
      { description: '50 Minuten', id: 50 },
      { description: '55 Minuten', id: 55 },
    ];


    this.selector.show({
      title: this.contentTranslation.translateContent('Select Activity Length'),
      positiveButtonText: this.contentTranslation.translateContent('Wheel OK'),
      negativeButtonText: this.contentTranslation.translateContent('Wheel Cancel'),
      items: [
        hoursSelect, minuteSelect
      ],
    }).then(
      result => {
        console.log(result);

        this.activityLengthFormatted = '';

        if(result[0].index) {
          this.activityLengthFormatted += (result[0].index == '1')?'1 Stunde ':result[0].index+" Stunden ";
        }
        if(result[1].index) {
          this.activityLengthFormatted += result[1].index?(result[1].index*5)+" Minuten":'';
        }

        this.activityLength = parseInt(result[0].index)*60+result[1].index*5;

      },
      err => console.log('Error: ', err)
    );

  }

}



// WEBPACK FOOTER //
// ./src/pages/app-step-update/app-step-update.ts